import useBillingPaymentMake from 'modules/queries/billing/payment/useMake';
import usePaypalPaymentCreate from 'modules/queries/billing/paypal/payment/useCreate';
import useBrandName from 'utility/hooks/useBrandName';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import ConfirmPaymentContent from './ConfirmPayment';
import useChosenPaymentMethod from '../useChosenPaymentMethod';
import useStripePayNow from '../useStripePayNow';

/** Confirms a payment on a method the account already has on file */
const ConfirmSavedPayment = () => {
	const { accountBalanceDisplay, formValues, onSubmitSuccess, onSubmitError } =
		useDialogMakePaymentContext();
	const { chosenPaymentMethod } = useChosenPaymentMethod();
	const {
		instrumentId,
		paymentMethod,
		paymentProfileId,
		processor,
		issuer,
		label = '',
		secondaryLabel,
	} = chosenPaymentMethod || {};
	const { mutate: makePayment, isLoading: isMakingPayment } =
		useBillingPaymentMake();
	const { mutate: paypalPaymentCreate, isLoading: isPaypalCreating } =
		usePaypalPaymentCreate();
	const { payNow: payNowWithStripe, isPaying: isPayingWithStripe } =
		useStripePayNow();
	const brandName = useBrandName();

	const { amount, cardCode } = formValues;

	const handleSubmit = () => {
		if (processor === 'stripe' && instrumentId) {
			payNowWithStripe({
				kind: 'savedCard',
				amount,
				paymentInstrumentId: instrumentId,
			});

			return;
		}

		if (processor === 'paypal') {
			paypalPaymentCreate(
				{
					requested_amount: amount,
					lineItems: [{ amount, description: `My ${brandName} Payment` }],
					returnURL: `${window.location.origin}/account/billing`,
				},
				{
					onSuccess: onSubmitSuccess,
					onError: onSubmitError,
				},
			);

			return;
		}

		if (paymentMethod === 'ach') {
			makePayment(
				{
					amount,
					payment_profile_id: paymentProfileId,
				},
				{
					onSuccess: onSubmitSuccess,
					onError: onSubmitError,
				},
			);

			return;
		}

		makePayment(
			{
				amount,
				card_code: cardCode,
				payment_profile_id: paymentProfileId,
			},
			{
				onSuccess: onSubmitSuccess,
				onError: onSubmitError,
			},
		);
	};

	return (
		<ConfirmPaymentContent
			accountBalance={Number(accountBalanceDisplay)}
			amount={Number(amount)}
			isSubmitting={isMakingPayment || isPaypalCreating || isPayingWithStripe}
			issuer={issuer}
			label={label}
			onSubmit={handleSubmit}
			paymentMethod={processor === 'paypal' ? 'paypal' : paymentMethod}
			secondaryLabel={secondaryLabel}
		/>
	);
};

export default ConfirmSavedPayment;
